export const chapterLocator = (chapters, position) => {
    for (let i = 0; i < chapters.length; i++) {
        const chapter = chapters[i];
        const prev = chapters[i - 1];
        if (position > chapter.location) {
            continue;
        }
        else if (position === chapter.location) {
            return {
                prev: i - 1 >= 0 ? i - 1 : undefined,
                current: chapter,
                next: i + 1 < chapters.length ? i + 1 : undefined,
            };
        }
        else if (prev) {
            return {
                prev: i - 2 >= 0 ? i - 2 : undefined,
                current: prev,
                next: i < chapters.length ? i : undefined,
            };
        }
        else {
            return {
                current: chapters[0],
                next: chapters.length > 0 ? 1 : undefined,
            };
        }
    }
    return {
        prev: chapters.length - 1,
        current: chapters[chapters.length - 1],
    };
};
//# sourceMappingURL=chapterLocator.js.map